export var TriggerSource;
(function (TriggerSource) {
    TriggerSource["NEWS_ALERT"] = "NEWS_ALERT";
    TriggerSource["PRICE_ALERT"] = "PRICE_ALERT";
})(TriggerSource || (TriggerSource = {}));
export var AutotradeTriggerCategory;
(function (AutotradeTriggerCategory) {
    AutotradeTriggerCategory["LISTING"] = "LISTING";
    AutotradeTriggerCategory["DELISTING"] = "DELISTING";
})(AutotradeTriggerCategory || (AutotradeTriggerCategory = {}));
export var TriggerPriceAlertType;
(function (TriggerPriceAlertType) {
    TriggerPriceAlertType["SPIKE"] = "SPIKE";
    TriggerPriceAlertType["DROP"] = "DROP";
})(TriggerPriceAlertType || (TriggerPriceAlertType = {}));
//# sourceMappingURL=trigger.types.js.map